const getTabList = (pageController, history) => {
  return [
    {
      label: 'Home',
      isActive: pageController.mainPage,
      onClick: () => history.push(`/`),
    },

    {
      label: 'Mini courses',
      isActive: pageController.courses,
      onClick: () => history.push(`/courses`),
    },
    {
      label: 'Collections',
      isActive: pageController.collections,
      onClick: () => history.push(`/collections`),
    },
  ]
}

export default getTabList
